<script setup lang="ts">
import { AisHierarchicalMenu } from 'vue-instantsearch/vue3/es'
import { vOnClickOutside } from '@vueuse/components'

defineProps<{
    /** Renders as a collapsible dropdown row (mobile filter drawer) instead of a static sidebar. */
    mobile?: boolean
}>()

const isOpen = ref(false)
</script>

<template>
    <ais-hierarchical-menu
        :attributes="['categories.lvl0', 'categories.lvl1', 'categories.lvl2']"
        separator=" > "
        :class-names="{
            'ais-HierarchicalMenu--noRefinement': 'hidden'
        }"
    >
        <template #default="{ items, refine, canRefine }">
            <div v-show="canRefine">
                <div v-if="mobile" v-on-click-outside="() => isOpen = false" class="filter-dropdown relative shrink-0">
                    <button
                        id="categories"
                        type="button"
                        tabindex="0"
                        class="group w-full flex justify-between items-center font-semibold min-h-11 py-3 pl-4 pr-1.5 border-b bg-base-100"
                        :class="{ 'bg-base-200': isOpen }"
                        @click="isOpen = !isOpen"
                    >
                        <span class="flex items-center min-h-11">{{ $t('search.filter.categoriesLabel') }}</span>

                        <span
                            class="w-11 h-11 rounded-full items-center flex justify-center hover:bg-tertiary-focus"
                            :class="{ 'bg-tertiary-focus rotate-180': isOpen }"
                        >
                            <MiscIcon name="chevron-down" />
                        </span>
                    </button>

                    <div
                        v-show="isOpen"
                        tabindex="0"
                        class="filter-dropdown-content max-h-[400px] xl:max-h-[450px] overflow-y-auto flex flex-col bg-base-100 z-20 border-b"
                    >
                        <div class="p-4">
                            <SearchSidebarMeiliCategory :items="items" :refine="refine" />
                        </div>
                    </div>
                </div>

                <nav v-else aria-labelledby="search-sidebar-categories-title">
                    <div id="search-sidebar-categories-title" class="mb-3 pb-2 font-semibold text-sm border-b leading-4">
                        {{ $t('search.filter.categoriesLabel') }}
                    </div>

                    <SearchSidebarMeiliCategory :items="items" :refine="refine" />
                </nav>
            </div>
        </template>
    </ais-hierarchical-menu>
</template>
